import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=19da915b"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports